import React from "react";

import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { authCommonStyles as commonStyles } from "@mapmycustomers/auth";
import { Button } from "@mapmycustomers/ui";

import Path from "@app/enum/Path";

import styles from "./LinkExpiredPage.module.scss";
import messages from "./messages";

interface Props {
  onManageUsersClick: () => void;
}

const LinkExpiredPage = ({ onManageUsersClick }: Props) => {
  const intl = useIntl();

  return (
    <section className={commonStyles.container}>
      <div className={styles.container}>
        <h1 className={commonStyles.title}>{intl.formatMessage(messages.invalidLinkTitle)}</h1>
        <span className={styles.description}>
          {intl.formatMessage(messages.invalidLinkMessage)}
        </span>
        <div className={styles.buttonContainer}>
          <Link to={Path.DASHBOARD}>
            <Button>{intl.formatMessage(messages.home)}</Button>
          </Link>
          <Button onClick={onManageUsersClick} type="primary">
            {intl.formatMessage(messages.manageUsers)}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default LinkExpiredPage;
